import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'complexFieldValue',
    standalone: false
})
export class ComplexFieldValuePipe implements PipeTransform {

  transform(value: string, ...args: any): string {
    if (!value)
    return '';
    try{
      const item = args && args.length > 0 ? args[0] : null;

      if (value === 'stockItemSites.account.name' || value === 'account' || value === 'account.name') {
        const list = item?.stockItemSites;
        if (Array.isArray(list) && list.length > 0) {
          const names = list
            .map((x: any) => x?.account?.name ?? x?.name)
            .filter((n: any): n is string => typeof n === 'string' && n.trim().length > 0);
          const uniqueNames = Array.from(new Set(names));
          if (uniqueNames.length > 0) return uniqueNames.join(', ');
        }
        return '';
      }

      if (value === 'site.code' || value === 'site.name' || value === 'stockItemSites.site.name' || value === 'stockItemSites.site.id' || value === 'stockItemSites.site.code') {
        const isCode = value === 'site.code' || value.endsWith('.id') || value.endsWith('.code');
        if (item?.site) {
          const val = isCode ? (item.site.code ?? item.site.id) : item.site.name;
          if (val !== null && val !== undefined && String(val).trim() !== '') {
            return String(val);
          }
        }
        const list = item?.stockItemSites;
        if (Array.isArray(list) && list.length > 0) {
          const sites = list
            .map((x: any) => isCode ? (x?.site?.code ?? x?.site?.id) : x?.site?.name)
            .filter((s: any): s is string => s !== null && s !== undefined && String(s).trim().length > 0);
          const uniqueSites = Array.from(new Set(sites));
          if (uniqueSites.length > 0) return uniqueSites.join(', ');
        }
        return 'All Sites';
      }

      if(value.includes('.')) {
        let props = value.split('.');
        switch(props.length){
          case 2:{
            let base = args[0][props[0]][0] ?? args[0][props[0]];
            let val = base ? base[props[1]] : null;
            if (props[0] === 'itemType' && props[1] === 'code' && !val) {
              return base ? (base.name ?? base.description) : '';
            }
            return val;
          }
          case 3:{
            let base = args[0][props[0]][0] ?? args[0][props[0]];
            if(value=='user.person.code')
              return base.userCode
            else {
              let val = base[props[1]] ? (base[props[1]][props[2]] ?? (base[props[1]][0] ? base[props[1]][0][props[2]] : null)) : null;
              if (props[1] === 'itemType' && props[2] === 'code' && !val) {
                let itemTypeObj = base[props[1]] ? (base[props[1]][0] ?? base[props[1]]) : null;
                return itemTypeObj ? (itemTypeObj.name ?? itemTypeObj.description) : '';
              }
              if (props[1] === 'costInfo' && props[2] === 'cost' && !val) {
                if (base && base['costInfo']) {
                  return base['costInfo']['cost'] ?? null;
                }
              }
              if (props[1] === 'inventoryUnitOfMeasure' && props[2] === 'symbol' && !val) {
                if (base && base['inventoryUnitOfMeasure']) {
                  return base['inventoryUnitOfMeasure']['symbol'] ?? null;
                }
              }
              if (props[1] === 'receiveUnitOfMeasure' && props[2] === 'symbol' && !val) {
                if (base && base['receiveUnitOfMeasure']) {
                  return base['receiveUnitOfMeasure']['symbol'] ?? null;
                }
              }
              return val;
            }

          }
          case 4:{
            let base = args[0][props[0]][props[1]][0] ?? args[0][props[0]][props[1]]
            return base[props[2]][props[3]];
          }
          case 5:{
            let base = args[0][props[0]][props[1]][props[2]][0] ?? args[0][props[0]][props[1]][props[2]]
            return base[props[3]][props[4]];
          }
        }
      }
      else{
        return args[0][value];
      }
    }
    catch (ex){
      // let result = (ex as Error).message;

      return '';
    }
  }
}
